const widget = {
  'admin.widgets.hetmet': 'Danh sách widget',
  'admin.widgets.breadcrumb.heading': 'Quản lý widget',
  'admin.widgets.breadcrumb.parent': 'Widgets',
  'admin.widgets.btn.add': 'Thêm widget',
  'admin.widget.modal.action.label.key': 'Khóa',
  'admin.widget.error-msg.key': 'Vui lòng nhập khóa',
  'admin.widget.error-msg.title': 'Vui lòng nhập tiêu đề',
  'admin.widget.error-msg.duplicate': 'Key bị trùng lặp',

  'admin.widget.modal.action.label.title': 'Tiêu đề',
  'admin.widget.modal.action.label.icon': 'Icon',
  'admin.widget.modal.action.label.group': 'Nhóm',
  'admin.widget.modal.action.label.group.name': 'Tên nhóm',
  'admin.widget.modal.action.label.group.slug': 'Link nhóm',
  'admin.widget.modal.action.label.description': 'Mô tả',
  'admin.widget.modal.action.label.type': 'Loại',
  'admin.widget.modal.action.title.create': 'Thêm widget',
  'admin.widget.modal.action.title.update': 'Cập nhật widget',
  'admin.widget.modal.action.title.details': 'Chi tiết widget',
  'admin.widget.modal.action.setting.order': 'Cài đặt khác',
  'admin.widget.modal.action.setting.option-count': 'lựa chọn',
  'admin.widget.modal.action.setting.field-count': 'trường dữ liệu',
  'admin.widget.modal.action.setting.api.path': 'URL hoặc Pathname',
  'admin.widget.modal.action.setting.api.object': 'Khóa chứa danh sách',
  'admin.widget.modal.action.setting.api.value': 'Khóa làm giá trị',
  'admin.widget.modal.action.setting.api.title': 'Khóa làm tiêu đề',
  'admin.widget.modal.action.setting.config.key': 'Khóa',
  'admin.widget.modal.action.setting.config.value': 'Giá trị',
  'admin.widget.modal.action.setting.config.title': 'Tiêu đề',
  'admin.widget.modal.action.setting.close': 'Đóng',
  'admin.widget.modal.action.setting.update': 'Cập nhật',
  'admin.widget.modal.action.setting.selectbox.label': 'Danh sách lựa chọn',
  'admin.widget.modal.action.setting.api.label': 'Cấu hình API',
  'admin.widget.modal.action.setting.list.label': 'Danh sách trường dữ liệu',
  'admin.widget.modal.action.setting.list.field': 'Kiểu dữ liệu',

  'admin.widget.content.section.label': 'Section',
  'admin.widget.content.section.add': 'Thêm section',

  'admin.widget.modal.delete.title': 'Xác nhận xóa widget',
  'admin.widget.modal.delete.description': 'Bạn chắc chắn xóa widget này?',

  'admin.widget.noti.create-widget.success': 'Thêm widget thành công',
  'admin.widget.noti.create-widget.failure': 'Tạo widget thất bại',

  'admin.widget.noti.update-widget.success': 'Cập nhật widget thành công',
  'admin.widget.noti.update-widget.failure': 'Cập nhật widget thất bại',

  'admin.widget.noti.delete-widget.success': 'Xóa widget thành công',
  'admin.widget.noti.delete-widget.failure': 'Xóa widget thất bại',
};

export default {
  ...widget,
};
